import { type FC } from "react";
import { type UserInformation } from "@clientFrontend/features/scout/types";
import { Cassettes } from "./uiParts/Cassettes";
import { MultiScoutCheckbox } from "./uiParts/MultiScoutCheckbox";
import { FixedButtons } from "./uiParts/FixedButtons";

type Props = {
  userInformationArray: UserInformation[];
  userStatusArray?: {
    userId: string;
    isChecked: boolean;
  }[];
  isMultiScout: boolean;
  updateSelectedUser: (value: string) => void;
  isMultiScoutChecked: boolean;
  updateAllUser: () => void;
  resetAllUser: () => void;
  scoutUrl?: string;
  checkedUserCount: number;
  scoutCount?: number;
  isShowCheckbox?: boolean;
  isDisabled: boolean;
  isShadow: boolean;
  isShowScoutNavigation: boolean;
  handleClickLink: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  isHiddenInitialValueArray?: boolean[];
  hiddenScoutUrl?: string;
  autoSelectAvailableRole?: boolean;
};

export const Presentation: FC<Props> = ({
  userInformationArray,
  userStatusArray,
  isMultiScout,
  updateSelectedUser,
  isMultiScoutChecked,
  updateAllUser,
  resetAllUser,
  scoutUrl,
  checkedUserCount,
  scoutCount,
  isShowCheckbox,
  isDisabled,
  isShadow,
  isShowScoutNavigation,
  handleClickLink,
  isHiddenInitialValueArray,
  hiddenScoutUrl,
  autoSelectAvailableRole,
}) => {
  return (
    <>
      {isMultiScout && (
        <MultiScoutCheckbox
          isMultiScoutChecked={isMultiScoutChecked}
          updateAllUser={updateAllUser}
          isDisabled={isDisabled}
        />
      )}
      <Cassettes
        userInformationArray={userInformationArray}
        isShowCheckbox={isShowCheckbox}
        userStatusArray={userStatusArray}
        handleChangeCheckbox={updateSelectedUser}
        isDisabled={isDisabled}
        isShadow={isShadow}
        isShowScoutNavigation={isShowScoutNavigation}
        isHiddenInitialValueArray={isHiddenInitialValueArray}
        hiddenScoutUrl={hiddenScoutUrl}
      />
      {isMultiScout && (
        <FixedButtons
          checkedUserCount={checkedUserCount}
          scoutCount={scoutCount}
          isDisabled={isDisabled}
          resetAllUser={resetAllUser}
          scoutUrl={scoutUrl}
          handleClickLink={handleClickLink}
          autoSelectAvailableRole={autoSelectAvailableRole}
        />
      )}
    </>
  );
};
